import { basePath, apiVersion } from './config';

export async function getPortalPrescriptionsApi({ token, page = 1, limit = 20 }) {
  const url = `${basePath}/${apiVersion}/get-prescriptions-portal?page=${page}&limit=${limit}`;

  const params = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
  };

  return await fetch(url, params)
    .then((response) => response.json())
    .catch((err) => ({ code: 500, message: err.message }));
}
